<form [formGroup]="form">
  <div class="d-lg-flex align-items-center mb-2">
    <app-client-autocomplete [(selectedClient)]="selectedClient" class="client-autocomplete me-2"></app-client-autocomplete>
    @if (selectedClient) {
      <div class="d-flex align-items-center">
        <label for="zoneId"
               class="control-label me-2">{{'i18n.domain.reports.filter.fields.zone' | translate}}:</label>
        <app-autocomplete [getDataFunction]="searchZoneAutocompleteValues.bind(this)"
                          [fields]="keyValueDropdownSettings"
                          [(value)]="selectedZone"
                          [isFormComponent]="true"
                          placeholder="i18n.domain.reports.filter.fields.zone-dropdown-placeholder"
                          id="zoneId">
        </app-autocomplete>
      </div>
    }
  </div>
</form>
